import path from 'path';
import { appConfigFileName, appConfigFileNamesJS, generatedConfigFileName } from './constants.js';

/**
 * Get config paths for the app at `cwd`.
 * @param cwd - base path of the config file
 * @param customConfigFileName - optional custom config file name to use instead of defaults
 */
export function getConfigPath(
  cwd: string,
  customConfigFileName?: string,
): {
  /** Default JSON app config path */
  defaultAppConfigPath: string;
  /** All app config paths including JSON and JS */
  appConfigPaths: string[];
  generatedConfigPath: string;
} {
  if (customConfigFileName) {
    const customConfigPath = path.resolve(cwd, customConfigFileName);
    return {
      defaultAppConfigPath: customConfigPath,
      appConfigPaths: [customConfigPath],
      generatedConfigPath: path.join(cwd, generatedConfigFileName),
    };
  }

  const defaultAppConfigPath = path.join(cwd, appConfigFileName);
  return {
    defaultAppConfigPath,
    appConfigPaths: [defaultAppConfigPath, ...appConfigFileNamesJS.map((fileName) => path.join(cwd, fileName))],
    generatedConfigPath: path.join(cwd, generatedConfigFileName),
  };
}
